module.exports = __webpack_public_path__ + "img/local-playlist-icon.8933e247.png";